import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IApiClientCustomKeys } from '../../store/api-client-context';

export enum CUSTOM_KEY_FORM_FIELD {
	KEY_NAME = 'description',
	NOTE = 'note'
}

export enum CUSTOM_KEY_FORM_FIELD_NAMES {
	KEY_NAME = 'Key name',
	NOTE = 'Note'
}

export type CustomKeyTypes = {
	[CUSTOM_KEY_FORM_FIELD.KEY_NAME]: string,
	[CUSTOM_KEY_FORM_FIELD.NOTE]: string,
}

export type CustomKeyReturnTypes = {
	description: string,
	note: string,
}

export const getCustomKeyDetailsSchema = (): Yup.SchemaOf<CustomKeyTypes> => Yup.object<Shape<CustomKeyTypes>>().shape({
	[CUSTOM_KEY_FORM_FIELD.KEY_NAME]: Yup.string()
		.required('Name is required'),
	[CUSTOM_KEY_FORM_FIELD.NOTE]: Yup.string()
		.max(50, 'Note must not be longer then 50 characters long'),
});

export const initialCustomKeyValues = {
	[CUSTOM_KEY_FORM_FIELD.KEY_NAME]: '',
};

export const getFormattedCustomKeyFormFields = (formikValues): CustomKeyReturnTypes => ({
	description: formikValues?.[CUSTOM_KEY_FORM_FIELD.KEY_NAME],
	note: formikValues?.[CUSTOM_KEY_FORM_FIELD.NOTE] ? formikValues?.[CUSTOM_KEY_FORM_FIELD.NOTE] : '',
});

export const getInitialCustomKeyFormFields = (data): CustomKeyTypes => ({
	[CUSTOM_KEY_FORM_FIELD.KEY_NAME]: data?.description,
	[CUSTOM_KEY_FORM_FIELD.NOTE]: data?.note ? data?.note : '',
});

export interface IFormattedProps {
	description: string;
	note: string;
	apiClient: string;
	scopes: string[];
}

export const getFormattedCustomKeyFormFValues = (data: IApiClientCustomKeys): IFormattedProps => ({
	description: data?.description ? data?.description : '',
	note: data?.note ? data?.note : '',
	apiClient: data?.clientId ? data?.clientId : '',
	scopes: data?.scopes ? data?.scopes : []
});
